// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XcvhFM {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

@media (max-width: 768px) {
  .XcvhFM {
    padding: 0 16px;
  }
}

@media (max-width: 480px) {
  .XcvhFM {
    padding: 0 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/pages/Billet/Billet.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".main {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n}\n\n@media (max-width: 768px) {\n  .main {\n    padding: 0 16px;\n  }\n}\n\n@media (max-width: 480px) {\n  .main {\n    padding: 0 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `XcvhFM`
};
module.exports = ___CSS_LOADER_EXPORT___;
